<template>
  <div>
    <!-- AppHeaderNew -->
    <AppHeaderNew />

    <!-- Banner Section -->
    <section class="banner" id="banner">
        <div class="video-wrapper">
            <video autoplay muted loop class="banner-video">
                <source src="../../assets/video/amejpay.mp4" type="video/mp4">
            </video>
        </div>
        <div class="container h-100">
            <div class="banner-text-wrapper">
                <div class="banner-text-container">
                    <div class="banner-texts">
                        <!-- <h1>Your Safe Money Wallet</h1>
                        <div class="d-none d-md-block">
                            <h4>Send, receive and pay from anywhere using mobile phone and internet service.</h4>
                            <a href="#">Sign Up</a>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- About Section -->
    <section class="about" id="about">
        <div class="container">
            <h3 class="text-center">About Amej Pay</h3>
            <div class="row">
                <div class="col-12 amejpay-introduction">
                    <p>
                        Amej Pay is a digital payment gateway that has its own safe and fast payment network. You can easily load and fund it and withdraw it. Every hotel will be the Merchant of Amej Pay. Amej Pay provides easy financial transactions globally through QR codes.
                    </p>
                </div>
            </div>
            <div class="row about-cards">
                <div class="col-md-4 col-sm-12">
                    <div class="card" id="about-gif-moneybag" 
                    @mouseover="isMoneyImageHover = true" 
                    @mouseleave="isMoneyImageHover = true"
                    >

                    <img v-if="isMoneyImageHover" class="card-img-top" src="../../assets/gifs/money-bags.gif" alt="Card image cap" />
                    <img v-else class="card-img-top" src="../../assets/about/money_bag.svg" alt="Card image cap" />

                        <div class="card-body">
                            <p>Amej Pay provides interest on your money.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12" id="about-gif-earth"
                @mouseover="isEarthImageHover = true" 
                @mouseleave="isEarthImageHover = true"
                > 
                    <div class="card">
                    <img v-if="isEarthImageHover" class="card-img-top" src="../../assets/gifs/earth.gif" alt="Card image cap">
                    <img v-else class="card-img-top" src="../../assets/about/earth.svg" alt="Card image cap">
                        <div class="card-body">
                            <p>Local Payment and International Payment.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12" id="about-gif-wallet"
                @mouseover="iswWalletImageHover = true" 
                @mouseleave="iswWalletImageHover = true"
                >
                    <div class="card">
                    <img v-if="iswWalletImageHover" class="card-img-top" id="about-gif-wallet-image" src="../../assets/gifs/wallets.gif" alt="Card image cap">
                    <img v-else class="card-img-top" id="about-gif-wallet-image" src="../../assets/about/wallet.svg" alt="Card image cap">
                        <div class="card-body">
                            <p>Load Amej Pay Wallet directly by Bank Deposit.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Features Section -->
    <section class="features" id="features">
        <div class="container">
            <h3 class="text-center">Features</h3>
            <div class="row">
                <div class="col-lg-8 col-md-7 col-sm-12 com-sm-12 features-list carousel slide" data-ride="carousel">
                    <ul>
                        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active">Easy Payment through QR Codes</li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1" class="active">Reduce Trouble of Currency Exchange</li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="2" class="active">Easy Wallet Up</li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="3" class="active">Transparent Transaction</li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="4" class="active">Support Other Networks</li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="5" class="active">Easy Load and Withdrawal of Fund</li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="6" class="active">Online Recharge using Debit/Credit Card</li>
                    </ul>
                </div>

                <div class="col-lg-4 col-md-5 col-sm-12 features-slider-box">
                    <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <div class="card">
                                    <img class="card-img-top" src="../../assets/features/qr.svg" alt="Card image cap">
                                    <div class="card-body">
                                        <p>Easy Payment through QR Codes</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="card">
                                    <img class="card-img-top" src="../../assets/features/convertor.svg" alt="Card image cap">
                                    <div class="card-body">
                                        <p>Reduce Trouble of Currency Exchange</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="card">
                                    <img class="card-img-top" src="../../assets/features/wallet.svg" alt="Card image cap">
                                    <div class="card-body">
                                        <p>Easy Wallet Up</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="card">
                                    <img class="card-img-top" src="../../assets/features/transparenttransaction.svg" alt="Card image cap">
                                    <div class="card-body">
                                        <p>Transparent Transaction</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="card">
                                    <img class="card-img-top" src="../../assets/features/network.svg" alt="Card image cap">
                                    <div class="card-body">
                                        <p>Support Other Networks</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="card">
                                    <img class="card-img-top" src="../../assets/features/easyload.svg" alt="Card image cap">
                                    <div class="card-body">
                                        <p>Easy Load and Withdrawal of Fund</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="card">
                                    <img class="card-img-top w-50" src="../../assets/features/cards.svg" alt="Card image cap">
                                    <div class="card-body">
                                        <p>Online Recharge using Debit/Credit Card</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
                    
            </div>
        </div>
    </section>

    <!-- Platform Section -->
    <section class="platform" id="platform">
      <div class="container">
        <h3 class="text-center">Global Digital Payment Gateway</h3>
        <div class="row">
          <div class="col-lg-8 col-md-12 platform-screenshots d-none d-md-block">
            <img class="desktop-screenshot" src="../../assets/platform/Gateway_Banner.jpg" alt />
            <img class="mobile-screenshot" src="../../assets/platform/iphone.png" alt />
          </div>
          <div class="col-lg-4 col-md-12 platform-download">
            <p>Send, receive and pay from anywhere using mobile phone and internet service.</p>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12 appstore">
                <a href="https://apps.apple.com/app/apay/id1566612928" target="_blank">
                  <img src="../../assets/icons/app store.png" alt class="download-icons" />
                </a>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 playstore">
                <a href="https://play.google.com/store/apps/details?id=com.amejpay.singapore&hl=en&gl=US" target="_blank">
                  <img src="../../assets/icons/google play.png" alt class="download-icons" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call To Action -->
    <section class="call-to-action text-center" id="call-to-action">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <!-- <img src="../../assets/icons/wallet.svg" alt=""> -->
            <h3>Get your Safe Money Wallet today.</h3>
            <router-link :to="{name: 'app'}">Get Now</router-link>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <SubscribeForm source="Homepage footer"></SubscribeForm>
</div>
        </div>
      </div>
    </section>

    <!-- FooterNew -->
    <AppFooterNew />

    <input type="hidden" name="onChangeStateValue">
  </div>
</template>

<script type="text/javascript">
import AppHeaderNew from "../reuseable_components/HeaderNew";
import SubscribeForm from "../reuseable_components/SubscribeForm.vue";
import AppFooterNew from "../reuseable_components/FooterNew";
import { mapActions, mapState } from "vuex";
export default {
  name: "Homepage",
  components: { SubscribeForm,
    AppHeaderNew,
    AppFooterNew,
  },
  data() {
    return {
      isMoneyImageHover: true,
      isEarthImageHover: true,
      iswWalletImageHover: true,
      onChangeStateValue: '',
      errors: [],
    };
  },
  computed: {
    ...mapState([
      "successmessage",
      "errormessage",
      "message",
    ]),
  },
  methods: {
  }
};
</script>